import FornecedorService from "@/services/FornecedorService";

export const fornecedor = {
  namespaced: true,
  state: {
    fornecedor: {},
  },
  actions: {
    getFornecedor({ commit }, payload) {
      return FornecedorService.GetFornecedor(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFornecedor({ commit }, payload) {
      return FornecedorService.PostFornecedor(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFornecedor({ commit }, payload) {
      return FornecedorService.PutFornecedor(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFornecedor({ commit }, payload) {
      return FornecedorService.DeleteFornecedor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFornecedorOData({ commit }, payload) {
      return FornecedorService.GetFornecedorOData(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    validate({ commit }, payload) {
      return FornecedorService.Validate(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    converter({ commit }, payload) {
      return FornecedorService.Converter(payload).then(
        (fornecedor) => {
          return Promise.resolve(fornecedor);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default fornecedor;
